import React from 'react';
import './UserJobs.css';
import { Job } from '@diditusa/shared/types/jobTypes';
import { format } from 'date-fns';
import { Button } from '@mui/material';

interface UserJobsProps {
  sortedJobs: Job[];
  onAgentNameClick?: (jobId: number) => void;
}

const UserJobs: React.FC<UserJobsProps> = ({ sortedJobs, onAgentNameClick }) => {
  const serviceOption = (option: number): string => {
    switch (option) {
      case 1:
        return 'Prestige Executive Package';
      case 2:
        return 'Essential Protection Package';
      case 3:
        return 'Signature Protection & Chauffeur Service';
      default:
        return 'N/A';
    }
  };

  return (
    <>
      <div className='user-jobs-header'>
        <h2>Your Upcoming Experience</h2>
      </div>

      <div className='user-jobs-wrapper'>
        {sortedJobs.map((job) => (
          <div key={job.id} className='user-job-card'>
            <div className='job-info-table'>
              <table>
                <tbody>
                  <tr>
                    <th>Reservation Number</th>
                    <td>
                      <Button
                        onClick={() => onAgentNameClick && onAgentNameClick(job.id)}
                        variant='text'
                      >
                        {job.reservationCode}
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <th>Service Option:</th>
                    <td>{serviceOption(job.securityOptionId)}</td>
                  </tr>
                  <tr>
                    <th>Date:</th>
                    <td>{job.startTime.toFormat('MM/dd/yyyy')}</td>
                  </tr>
                  <tr>
                    <th>Time:</th>
                    <td>{job.startTime.toFormat('hh:mm a ZZZZ')}</td>
                  </tr>
                  <tr>
                    <th>Duration:</th>
                    <td>{job.durationHours} Hours</td>
                  </tr>
                  <tr>
                    <th>Agent Assigned:</th>
                    <td>
                      {job.jobAssignments?.map((ja) => (
                        <Button
                          onClick={() => onAgentNameClick && onAgentNameClick(job.id)}
                          variant='text'
                        >
                          {`${ja.user?.firstName} ${ja.user?.lastName}`}
                        </Button>
                      ))}
                    </td>
                  </tr>
                  <tr>
                    <th>Address:</th>
                    <td>{job.location}</td>
                  </tr>
                  <tr>
                    <th>Description:</th>
                    <td>{job.description}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default UserJobs;
